import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class StudentFeedbackService {
 jwt = '';
  constructor(private http: HttpClient, public baseURL: BasemodelService) { }
    getstate() {
      const headers = new HttpHeaders({
        'Authorization': this.jwt,
      });
      return this.http.get(this.baseURL.getCommonUrl() + "/apiV2/common/employeeStates", { headers })
  
    }
    getcity(stateId: any) {
      const headers = new HttpHeaders({
        'Authorization': this.jwt,
      });
      return this.http.get(this.baseURL.getCommonUrl() + "/apiV2/common/emplStateCities?stateId=" + stateId, { headers })
  
    }
    getcampus(cityId: any) {
      const headers = new HttpHeaders({
        'Authorization': this.jwt,
      });
      return this.http.get(this.baseURL.getCommonUrl() + "/apiV2/common/empCityCampuses?cityId=" + cityId, { headers })
    }
    getstudentfeedback(params:any){
      const headers = new HttpHeaders({
    'Authorization': this.jwt,
  });

  let httpParams = new HttpParams()
    .set('categoryName', params.categoryName); // ✅ Mandatory

  if (params.stateId) {
    httpParams = httpParams.set('stateId', params.stateId);
  }

  if (params.cityId) {
    httpParams = httpParams.set('cityId', params.cityId);
  }

  if (params.campusId) {
    httpParams = httpParams.set('campusId', params.campusId);
  }
 
  if (params.fromDate) {
    httpParams = httpParams.set('fromDate', params.fromDate);
  }

  if (params.toDate) {
    httpParams = httpParams.set('toDate', params.toDate);
  }

  return this.http.get(
    this.baseURL.getCommonUrl() + '/employee/api/jwtV2/stdDashboard/feedbackReport',
    { headers, params: httpParams }
  );
  }
}
